/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Shared page context fields used across GTM events.
 * Consolidates repeated typeof-guarded browser globals.
 */
export interface PageContext {
    page_title: string;
    page: string;
    referral_page: string;
}

export function getPageContext(): PageContext {
    return {
        page_title: typeof document !== 'undefined' ? document.title : '',
        page: typeof window !== 'undefined' ? window.location.pathname + window.location.search : '',
        referral_page: typeof document !== 'undefined' ? document.referrer : '',
    };
}
